<p-toast></p-toast>

<!-- Adicionada classe 'modal-overlay' para garantir posicionamento -->
<div *ngIf="reviewService.visible()" class="modal-overlay" role="dialog" aria-modal="true">

  <!-- Backdrop -->
  <div [@overlayAnimation] class="modal-backdrop" (click)="closeDialog()"></div>

  <!-- Modal Panel -->
  <div [@dialogAnimation] class="modal-panel">

    <!-- Header -->
    <div class="modal-header">
      <h3>Escreva sua avaliação</h3>
      <button (click)="closeDialog()" style="color: #9ca3af;" class="hover:text-gray-500">
        <!-- CORREÇÃO: Estilo explícito de tamanho para o SVG -->
        <svg style="width: 24px; height: 24px;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Content Scrollable -->
    <div class="modal-body">
      <div class="layout-columns">

        <!-- Lado Esquerdo: Resumo do Produto -->
        <div class="col-left flex flex-col gap-6">
          <div class="bg-gray-50 rounded-lg p-4 flex items-center justify-center border border-gray-100">
            <img [src]="product().image" class="max-h-40 object-contain mix-blend-multiply"
              [style]="{'display': 'block', 'margin': '0 auto'}">
          </div>

          <div class="text-center">
            <h3 [style]="{'font-size': '1rem', 'margin-bottom': '0.5rem'}">{{ product()?.name }}</h3>

            <div class="flex items-center justify-center gap-2 mt-2"
              [style]="{'display': 'flex', 'justify-content': 'center', 'gap': '0.5rem'}">
              <span [style]="{'font-size': '1rem', 'margin-bottom': '0.5rem', 'font-weight': 'bold'}" class="fs-3 font-bold text-dark-900">{{ product().averageRating }}</span>
              <div class="flex text-yellow-400 text-lg" [style]="{'display': 'flex', 'color': '#facc15'}">
                <ng-container *ngFor="let star of [1,2,3,4,5]">
                  <!-- CORREÇÃO: Tamanho explícito 20px para estrelas pequenas -->
                  <svg *ngIf="star <= Math.round(product().averageRating)" [style]="{'width': '20px', 'height': '20px'}"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <svg *ngIf="star > Math.round(product().averageRating)"
                    [style]="{'width': '20px', 'height': '20px', 'color': '#d1d5db'}" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20" fill="currentColor">
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                </ng-container>
              </div>
            </div>
            <span class="text-sm text-gray-500 mt-1 block">({{ product().totalReviews }} avaliações)</span>
          </div>

          <div class="space-y-2" [style]="{'margin-top': '1rem'}">
            <div *ngFor="let dist of product().distribution" class="flex items-center text-xs"
              [style]="{'display': 'flex', 'align-items': 'center', 'font-size': '0.75rem', 'margin-bottom': '0.25rem'}">
              <span [style]="{'width': '2rem', 'text-align': 'right', 'margin-right': '0.5rem', 'color': '#4b5563'}">{{ dist.stars }}★</span>
              <div [style]="{'flex': '1', 'height': '0.5rem', 'background': '#f3f4f6', 'border-radius': '9999px', 'overflow': 'hidden'}">
                <div [style]="{'height': '100%', 'background': '#facc15'}" [style.width.%]="dist.percentage"></div>
              </div>
              <span [style]="{'width': '2.5rem', 'text-align': 'right', 'color': '#6b7280'}">{{ dist.percentage }}%</span>
            </div>
          </div>
        </div>

        <!-- Lado Direito: Formulário -->
        <div class="col-right flex flex-col gap-6">

          <div class="bg-gray-50 p-4 rounded-lg border border-gray-100"
            [style]="{'padding': '1rem', 'background': '#f9fafb', 'border': '1px solid #f3f4f6', 'border-radius': '0.5rem'}">
            <label class="block text-sm font-semibold text-gray-700 mb-2">Qual sua nota geral?</label>
            <div class="flex items-center gap-3" [style]="{'display': 'flex', 'align-items': 'center', 'gap': '0.75rem'}">
              <div class="flex gap-1" (mouseleave)="hoverRating = 0" [style]="{'display': 'flex'}">
                <button *ngFor="let star of [1,2,3,4,5]" (mouseenter)="hoverRating = star" (click)="userRating = star"
                  class="focus:outline-none transition-transform hover:scale-110"
                  [style.color]="star <= (hoverRating || userRating) ? '#facc15' : '#d1d5db'">
                  <!-- CORREÇÃO: Tamanho explícito 32px para estrelas grandes (input) -->
                  <svg xmlns="http://www.w3.org/2000/svg" [style]="{'width': '32px', 'height': '32px'}" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                </button>
              </div>
              <span class="text-sm font-medium text-yellow-600 px-2 py-1 bg-yellow-50 rounded" *ngIf="userRating > 0"
                [style]="{'background': '#fefce8', 'color': '#ca8a04', 'padding': '0.25rem 0.5rem', 'border-radius': '0.25rem', 'font-size': '0.875rem'}">
                {{ getRatingLabel(userRating) }}
              </span>
            </div>
          </div>

          <div class="flex flex-col gap-2">
            <label for="title" class="text-sm font-medium text-gray-700">Título da avaliação</label>
            <input type="text" id="title" [(ngModel)]="reviewTitle"
              placeholder="Ex: Excelente qualidade de som, mas..." />
          </div>

          <div class="flex flex-col gap-2">
            <label for="review" class="text-sm font-medium text-gray-700">O que você achou do produto?</label>
            <textarea id="review" [(ngModel)]="reviewText" rows="4"
              placeholder="Conte-nos os prós e contras..."></textarea>
          </div>

          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium text-gray-700">Adicionar fotos <!--ou vídeo--></label>

            <div
              class="border-2 border-dashed border-gray-300 rounded-lg p-6 hover:bg-gray-50 transition-colors text-center cursor-pointer"
              (click)="fileInput.click()"
              style="border: 2px dashed #d1d5db; padding: 1.5rem; border-radius: 0.5rem; text-align: center;">
              <input #fileInput type="file" (change)="onFileSelect($event)" accept="image/*" class="hidden"
                style="display: none;">

              <div class="flex flex-col items-center justify-center gap-2" *ngIf="uploadedImages.length === 0">
                <div class="p-3 bg-indigo-50 rounded-full text-indigo-600"
                  style="display: inline-block; padding: 0.75rem; background: #eef2ff; color: #4f46e5; border-radius: 9999px;">
                  <!-- CORREÇÃO: Tamanho explícito 24px para ícone de upload -->
                  <svg xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px;" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div style="margin-top: 0.5rem;">
                  <span class="text-sm font-medium text-indigo-600" style="color: #4f46e5; font-weight: 500;">Clique
                    para selecionar arquivos</span>
                </div>
              </div>

              <div class="flex gap-4 overflow-x-auto justify-center" *ngIf="uploadedImages.length > 0"
                style="display: flex; gap: 1rem; justify-content: center;">
                <div *ngFor="let img of uploadedImages; let i = index" class="relative group"
                  style="position: relative;">
                  <img [src]="img.url"
                    style="width: 6rem; height: 6rem; object-fit: cover; border-radius: 0.5rem; border: 1px solid #e5e7eb;">
                  <button (click)="removeImage(i); $event.stopPropagation()"
                    style="position: absolute; top: -0.5rem; right: -0.5rem; background: #ef4444; color: white; border-radius: 9999px; padding: 0.25rem; width: 1.5rem; height: 1.5rem; display: flex; align-items: center; justify-content: center;">
                    <!-- CORREÇÃO: Tamanho explícito 12px para ícone de remover -->
                    <svg style="width: 12px; height: 12px;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button (click)="closeDialog()" class="btn btn-cancel">
        Cancelar
      </button>
      <button (click)="submitReview()" [disabled]="!isValid()" class="btn btn-submit">
        <!-- CORREÇÃO: Tamanho explícito 16px para ícone do botão enviar -->
        <svg *ngIf="isValid()" style="width: 16px; height: 16px;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Enviar Avaliação
      </button>
    </div>

  </div>
</div>
